import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Paper,
  Avatar,
  IconButton,
  Grid,
} from "@mui/material";
import {
  Add as AddIcon,
  Work as WorkIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";

const WorkExperienceStep = ({
  formData,
  updateFormData,
  onAddExperience,
  setIsValid
  , errors, setErrors
}) => {
  // const [errors, setErrors] = useState({
  //   description: "",
  // });

  useEffect(() => {
    // Set validation state based on current errors
    const isValid = Object.values(errors).every((error) => error === "");
    setIsValid(isValid); // Pass validation status back to parent
  }, [errors]);


  const validateField = (name, value) => {
    let errorMessage = "";
    switch (name) {
      case "description":
        if (value === "") {
          errorMessage = "Description is required";
        } else if (value.length > 500) {
          errorMessage = "Description cannot exceed 500 characters";
        }
        break;
      default:
        break;
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errorMessage,
    }));
    return errorMessage;
  };



  const handleDescriptionChange = (e) => {
    const { name, value } = e.target;
    validateField(name, value);
    updateFormData("description", e.target.value);

  };

  const handleRemoveExperience = (indexToRemove) => {
    // Filter out the experience at the specified index
    const updatedExperiences = formData.work_experience.filter(
      (_, index) => index !== indexToRemove
    );
    // Update formData with the new array (make sure `updateFormData` is correctly updating the state)
    updateFormData("work_experience", updatedExperiences); // Note: Ensure that 'work_experience' is the correct key
  };


  return (
    <Box>
      <Box sx={{ mb: 4 }}>
        <Typography variant="subtitle1" gutterBottom>
          Previous Work
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          List your past projects or experiences
        </Typography>

        <Paper
          variant="outlined"
          sx={{
            p: 3,
            borderStyle: "dashed",
            borderWidth: "3px",
            borderRadius: 4,
            mb: 3,
          }}
        >
          {formData.work_experience && formData.work_experience.length > 0 ? (
            <Box>
              {formData.work_experience.map((exp, index) => (
                <Box
                  key={exp.job_title + exp.organization + exp.starting} // Using a combination to make a unique key
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    mb: 2,
                    position: "relative",
                    flexDirection: { xs: "column", sm: "row" },
                  }}
                >
                  <Avatar
                    sx={{
                      bgcolor: "primary.light",
                      color: "white",
                      mr: { xs: 0, sm: 2 },
                      mb: { xs: 1, sm: 0 },
                    }}
                  >
                    <WorkIcon />
                  </Avatar>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="body1" fontWeight="medium">
                      {exp.job_title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {exp.organization}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {exp.starting} - {exp.end ? exp.end : "Present"}
                    </Typography>
                  </Box>
                  <IconButton
                    size="medium"
                    color="error"
                    onClick={() => handleRemoveExperience(index)} // Passing the index to handleRemoveExperience
                    sx={{ position: "absolute", top: 0, right: 0 }}
                  >
                    <DeleteIcon fontSize="medium" />
                  </IconButton>
                </Box>
              ))}
            </Box>
          ) : (
            <Box sx={{ textAlign: "center", py: 2 }}>
              <Typography variant="body2" color="text.secondary">
                No work experience added yet
              </Typography>
            </Box>
          )}

          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={onAddExperience}
            sx={{
              mt: 2,
              borderRadius: 8,
              borderColor: "primary.main",
              color: "primary.main",
              width: { xs: "100%", sm: "auto" },
            }}
          >
            Add experience
          </Button>
        </Paper>
      </Box>

      <Box>
        <Typography variant="subtitle1" gutterBottom>
          Description<span style={{ color: 'red' }}>*</span>
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Tell customers about your services and expertise:
        </Typography>
        <TextField
          fullWidth
          multiline
          name="description"
          rows={6}
          value={formData.description}
          // error={!!errors.description}
          // helperText={errors.description}
          onChange={handleDescriptionChange}
          variant="outlined"
          placeholder="Describe your experience, expertise, and the value you provide to clients..."
          sx={{
            mb: 1,
            backgroundColor: "rgba(211, 211, 211, 0.15)",
            "& .MuiOutlinedInput-root": {
              backgroundColor: "rgba(211, 211, 211, 0.19)",
              borderRadius: "12px",
            },
          }}
        />
        <Typography
          variant="caption"
          color={errors.description ? 'error' : 'text.secondary'}
          align="right"
          sx={{ display: "block" }}
        >
          {errors.description
            ? errors.description // Show the error if it's present
            : `Character limit: ${formData?.description?.length}/500`}
        </Typography>


      </Box>
    </Box>
  );
};

export default WorkExperienceStep;
